
import './InfosSpecialites.css'

const InfosSpecialites = ({ item }) => {

    const renderItems = () =>
    {
        if (item.Specialites == null) {
            return (
                <div className="txt-none">
                    Aucune spécialité complémentaire renseignée
                </div>
            )
        }
        return (
            <ul className="spec-items">
                {item.Specialites.map((item, index) => <li key={index }>{item}</li>) }
            </ul>
        )
    }

    return (
        <div className="info-specialites">
            <div className="title">{item.LibelleTypeEntite}</div>
            {renderItems()}
        </div>
    )
}

export default InfosSpecialites